module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAAXNSR0IArs4c6QAAAGxQTFRFAAAA//8A9MoA9tAA+M0A8tAA8tEA8s0A89AA9M0A8c4A8c8A8s0A884A9NAA8s8A8s8A884A9NAA8s8A8c0A884A888A8s4A8s8A888A8s4A884A884A8s4A8s8A8s4A8s4A8s8A884A8s4ALrEEnQAAACN0Uk5TAAEYGyQmJz1BSElLTVhhZGV+jI6QkZadrrrC1trb4Oru8/bz2PGbAAAAXUlEQVQI103MVxKAMAgEUGyx9xq7cv87GgTLfu2bgYVOax2CSWlKCsGEmBtViNhbAOPNWsRsHhGL9hVx+UT8iUlK9khIGmaMmfel7wjlz2Y+K8xMtB54bvDGVUp5F0vKCyDrAFf3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip1.png
// module id = tOzr
// module chunks = 1